import { useCallback, useRef, useState } from 'react';

const DEFAULT_DELAY_MS = 1000;

export interface DelayedTooltipState {
  openTooltip: string | null;
  setOpenTooltip: React.Dispatch<React.SetStateAction<string | null>>;
  handleTooltipMouseEnter: (key: string) => void;
  handleTooltipMouseLeave: () => void;
}

export function useDelayedTooltip(
  delayMs = DEFAULT_DELAY_MS
): DelayedTooltipState {
  const [openTooltip, setOpenTooltip] = useState<string | null>(null);
  const tooltipTimerRef = useRef<NodeJS.Timeout | null>(null);

  const handleTooltipMouseEnter = useCallback(
    (key: string) => {
      if (tooltipTimerRef.current) {
        clearTimeout(tooltipTimerRef.current);
      }
      tooltipTimerRef.current = setTimeout(() => {
        setOpenTooltip(key);
      }, delayMs);
    },
    [delayMs]
  );

  const handleTooltipMouseLeave = useCallback(() => {
    if (tooltipTimerRef.current) {
      clearTimeout(tooltipTimerRef.current);
    }
    setOpenTooltip(null);
  }, []);

  return {
    openTooltip,
    setOpenTooltip,
    handleTooltipMouseEnter,
    handleTooltipMouseLeave
  };
}
